import { colorMode } from "./posColors";

const STYLE_FIELDS = ["bw", "bh", "fontScale", "fontFamily", "bold", "italic", "underline", "strike", "alignH", "alignV", "borderColor", "borderWidth", "bgOpacity", "borderOpacity"];

// key -> on-screen CSS stack + font embedded in exported PDFs (see pdfCore FONT_FILES)
export const BUBBLE_FONTS = [
    { key: "default", label: "Default (Mono)", css: null, pdf: "mono" },
    { key: "arial", label: "Arial", css: "Arial, 'Liberation Sans', sans-serif", pdf: "sans" },
    { key: "calibri", label: "Calibri", css: "Calibri, Carlito, sans-serif", pdf: "calibri" },
    { key: "aptos", label: "Aptos", css: "Aptos, 'Open Sans', sans-serif", pdf: "opensans" },
    { key: "helvetica", label: "Helvetica", css: "Helvetica, Arial, 'Liberation Sans', sans-serif", pdf: "sans" },
    { key: "roboto", label: "Roboto", css: "Roboto, sans-serif", pdf: "roboto" },
    { key: "opensans", label: "Open Sans", css: "'Open Sans', sans-serif", pdf: "opensans" },
    { key: "times", label: "Times New Roman", css: "'Times New Roman', 'Liberation Serif', serif", pdf: "serif" },
    { key: "courier", label: "Courier New", css: "'Courier New', 'Liberation Mono', monospace", pdf: "mono" },
];
export const bubbleFont = (key) => BUBBLE_FONTS.find((f) => f.key === key) || BUBBLE_FONTS[0];

export const bubbleBase = (tray) => ({
    scale: tray.bubble_scale || 1,
    shape: tray.bubble_shape || "circle",
    bg: colorMode(tray) === "uniform" ? (tray.bubble_color || null) : null,
    textColor: tray.text_color || "#ffffff",
    noFill: !!tray.no_fill,
    rotation: tray.bubble_rotation || 0,
    bw: tray.bubble_w ?? null, bh: tray.bubble_h ?? null, fontScale: tray.font_scale ?? 1, fontFamily: tray.font_family || "default",
    bold: tray.font_bold ?? true, italic: !!tray.font_italic, underline: !!tray.font_underline, strike: !!tray.font_strike,
    alignH: tray.align_h || "center", alignV: tray.align_v || "middle",
    borderColor: tray.border_color ?? null, borderWidth: tray.border_width ?? 2,
    bgOpacity: tray.bg_opacity ?? 1, borderOpacity: tray.border_opacity ?? null,
});

// Resolved border/fill colours shared by the viewer and the PDF export. px = bubble base size.
export function bubblePaint(st, autoColor, px) {
    const tone = st.bg || autoColor;
    return {
        fill: st.noFill ? null : tone,
        fillOpacity: st.bgOpacity ?? 1,
        border: st.borderColor || (st.noFill ? tone : "#ffffff"),
        borderOpacity: st.borderOpacity ?? (st.noFill || st.borderColor ? 1 : 0.8),
        borderWidth: (px * (st.borderWidth ?? 2)) / 30,
    };
}

export function effBubbleStyle(tray, bubbleStyles, unitId) {
    const base = bubbleBase(tray);
    const o = tray.apply_all !== false ? {} : ((bubbleStyles || {})[unitId] || {});
    const extra = Object.fromEntries(STYLE_FIELDS.map((f) => [f, o[f] !== undefined ? o[f] : base[f]]));
    return {
        ...extra,
        scale: o.scale ?? base.scale,
        shape: o.shape ?? base.shape,
        bg: o.bg !== undefined ? o.bg : base.bg,
        textColor: o.textColor ?? base.textColor,
        noFill: o.noFill ?? base.noFill,
        rotation: o.rotation ?? base.rotation,
    };
}
